import GenericBinding from './GenericBinding';

var FileBinding = (function (GenericBinding) {
	function FileBinding () {
		GenericBinding.apply(this, arguments);
	}

	if ( GenericBinding ) FileBinding.__proto__ = GenericBinding;
	FileBinding.prototype = Object.create( GenericBinding && GenericBinding.prototype );
	FileBinding.prototype.constructor = FileBinding;

	FileBinding.prototype.getInitialValue = function getInitialValue () {
		return undefined;
	};

	FileBinding.prototype.getValue = function getValue () {
		return this.node.files;
	};

	FileBinding.prototype.render = function render () {
		this.element.lazy = false;
		GenericBinding.prototype.render.call(this);
	};

	FileBinding.prototype.setFromNode = function setFromNode ( node ) {
		this.model.set( node.files );
	};

	return FileBinding;
}(GenericBinding));

export default FileBinding;


//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/view/items/element/binding/FileBinding.js.map
